import { Injectable, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { HttpError } from '../errors';
import { Subject } from 'rxjs/Subject';
import { SemsoEncryptionModule } from 'app/encryption/encryption.module';
import { Shortlist } from './shortlist';

@Injectable()
export class ShortlistService {
  private retrievalErrorBase = new Subject<boolean>();
  public retrievalError$ = this.retrievalErrorBase.asObservable();

  constructor(
    private http: HttpClient,
    private encryption: SemsoEncryptionModule
  ) { }

  @Output() update: EventEmitter<boolean> = new EventEmitter();

  public refresh() {
    this.update.emit();
  }

  public getShortlist(): any {    
    return this.http.get<Shortlist[]>(`/shortlist`).pipe(catchError(error => {
      this.retrievalErrorBase.next(false);
      throw new HttpError(`Error retrieving shortlist`);
    }));
  }

  public addToShortlist(studentId: string, creboId: string): any {
    return this.http.post<any>(`/shortlist/${creboId}/${studentId}`, {}).pipe(catchError(error => {
      this.retrievalErrorBase.next(false);
      throw new HttpError(`Error add to shortlist for student: ${studentId}`);
    }));
  }

  public removeFromShortlist(studentId: string, creboId: string): any {
    return this.http.delete<any>(`/shortlist/${creboId}/${studentId}`, {}).pipe(catchError(error => {
      this.retrievalErrorBase.next(false);
      throw new HttpError(`Error remove from shortlist for student: ${studentId}`);
    }));
  }

  public clearShortlist(): any {
    return this.http.delete<any>(`/shortlist/clear`, {}).pipe(catchError(error => {
      this.retrievalErrorBase.next(false);
      throw new HttpError(`Error clear shortlist`);
    }));
  }
}



// WEBPACK FOOTER //
// ./src/app/students/shortlist.service.ts